import { render, staticRenderFns } from "./PortfolioCarouselItem.vue?vue&type=template&id=bbd27b0a&scoped=true"
import script from "./PortfolioCarouselItem.vue?vue&type=script&lang=ts"
export * from "./PortfolioCarouselItem.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioCarouselItem.vue?vue&type=style&index=0&id=bbd27b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd27b0a",
  null
  
)

export default component.exports